<app-modal-window [title]="isLocking ? 'Установка блокировки' : 'Снятие блокировки'"
                  [actions]="true"
                  [disabledConfirm]="reason.invalid"
                  (close)="close()"
                  (confirm)="confirm()">
  <div class="lock-modal-content">
    <mat-form-field appearance="outline" class="reason">
      <mat-label>Причина</mat-label>
      <input matInput type="text" placeholder="Причина" [formControl]="reason">
    </mat-form-field>

    <ng-container *ngIf="isLocking">
      <mat-form-field appearance="outline" class="expires">
        <mat-label>Срок действия (необязательно)</mat-label>
        <input matInput type="datetime-local" [formControl]="expiresAt">
      </mat-form-field>
      <p class="expires-hint">
        Момент, когда блокировка <b>автоматически перестанет действовать</b> (станет неактивной,
        строка лока перестанет учитываться). Оставьте пустым — блокировка <b>бессрочная</b>, до ручного снятия.
      </p>
    </ng-container>
  </div>
</app-modal-window>
